import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";

export const LANGS = [
  { code: "es", label: "Español",   flag: "🇪🇸" },
  { code: "en", label: "English",   flag: "🇬🇧" },
  { code: "it", label: "Italiano",  flag: "🇮🇹" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { t: es }, en: { t: en }, it: { t: it }, pt: { t: pt } },
    fallbackLng: "es",
    defaultNS: "t",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "op_lang",
    },
  });

export default i18n;
